/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ApiAction } from "../../commons/types/ApiAction";
export const ApiActionsResponse = core.serialization.object({
    data: core.serialization.list(ApiAction),
});
